import BaseService from "./BaseService";
import { IExportExcel } from "../core/contracts/IExportExcel";
import { saveAs } from "file-saver";
import IHtml from "../core/contracts/IHtml";

export default class ExportFileService extends BaseService {
  async exportExcelLevelHistory(fileData: IExportExcel): Promise<boolean> {
    try {
      const file = await new BaseService(true, true).post<Blob, IExportExcel>(
        "/core/Export/GetExcelFileLevelHistory",
        fileData
      );

      const blob = new Blob([file], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileData.fileName + ".xlsx");

      return true;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("ExportFileService -> exportExcelLevelHistory -> error", error);
      return Promise.reject(error);
    }
  }

  async exportExcelConsumptionHistory(fileData: IExportExcel): Promise<boolean> {
    try {
      const file = await new BaseService(true, true).post<Blob, IExportExcel>(
        "/core/Export/GetExcelFileConsumptionHistory",
        fileData
      );

      const blob = new Blob([file], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileData.fileName + ".xlsx");

      return true;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("ExportFileService -> exportExcelConsumptionHistory -> error", error);
      return Promise.reject(error);
    }
  }

  async exportPdfFromHtml(htmlData: IHtml): Promise<boolean> {
    try {
      const file = await new BaseService(true, true).post<Blob, IHtml>(
        "/core/Export/GetPdfFromHtml",
        htmlData
      );

      const blob = new Blob([file], {
        type: "application/pdf",
      });
      saveAs(blob, htmlData.fileName + ".pdf");

      return true;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("ExportFileService -> exportPdfFromHtml -> error", error);
      return Promise.reject(error);
    }
  }
}
